import {customElement} from 'lit/decorators.js';
import {FilterView} from './filter-view';
import {Activity} from './activity';
import {ri} from './runner-idle';
import {Filter, Filterable} from './interfaces/filterable';
import {Batch} from './batch';
import {
  BehaviorSubject,
  combineLatest,
  filter,
  from,
  identity,
  interval,
  map,
  Observable,
  of,
  tap,
} from 'rxjs';
import {all, any, T} from 'ramda';
import {any$} from './utils';

@customElement('ri-activities')
export class Activities extends FilterView {
  // #region Properties (3)

  public override id = 'activities';
  public override name = 'Activities';
  public override isIntersection = true;
  public override helpContent =
    'Click or drag to the queue. R-Click to edit a batch. Control + click to hide/show. Alt + click to delete batches.';
  public override masonryOptions = {
    columnWidth: 1,
  };
  public override replacementEntryTag = 'ri-activity, ri-batch';

  // #endregion Properties (3)

  // #region Constructors (1)

  // possibleFilters$: Observable<Set<Filter>> = combineLatest([ interval(1000),...Object.values(ri.resources).map(resource => resource.unlock$)]).pipe(map(([resources]) => resources.filter(resource => resource.unlock)))
  // // im replacing the below with the above
  //  new BehaviorSubject(
  //   new Set([
  //     ...Object.values(ri.resources)
  //       .filter(
  //         (resource) => resource.unlocked && !resource.name.includes('Exp')
  //       )
  //       .map((resource) => ({
  //         name: resource.name,
  //         displayName: resource.displayName,
  //       })),
  //     // {name: 'combat', displayName: 'Combat'},
  //     {name: 'travel', displayName: 'Travel'},
  //     {name: 'meditate', displayName: 'Meditation'},
  //     {name: 'train', displayName: 'Training'},
  //     ...Object.values(ri.stats)
  //       .filter((stat) => stat.unlocked)
  //       .map((stat) => ({
  //         name: stat.name,
  //         displayName: stat.displayName,
  //       })),
  //     {
  //       name: 'hiddenByPlayer',
  //       displayName: 'Hidden',
  //       condition: (a) => a.hiddenByPlayer ?? false,
  //     },
  //     {
  //       name: 'batches',
  //       displayName: 'Batches',
  //       only: true,
  //       condition: (a) => a instanceof Batch,
  //     },
  //   ])
  // );
  constructor() {
    super();
    this.filterables$ = of(Object.values(ri.activities));
    this.unlock$ = of(true);
    // this.unlock$ = any$([
    //   ri.activities.jog.unlock$,
    //   ri.activities.meditate.unlock$,
    // ]);
  }

  // #endregion Constructors (1)
}
